import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Container from "reactstrap/lib/Container";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import Districts from "Containers/DistrictsContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import TopProviderContainer from "Containers/TopProviderContainer";
import { SeoBlockContainer } from "Containers/SeoBlock";
import { AddressAdverBlockContainer } from "Containers/AdBlocksContainer";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import Metrika from "Services/Metrika";
import ProvidersContainer from "Containers/Providers/ProvidersContainer";

@inject("ApplicationModel")
@observer
class Page extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Providers.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	handleChoose(value) {
		if (value === "home") {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_FLAT_BUTTON
			);
		} else {
			Metrika.getInstance().google.sendEvent(
				EVENT_CATEGORY_CLICK_BUTTON,
				EVENT_ACTION_CLICK_OFFICE_BUTTON
			);
		}
	}

	render() {
		const route = this.props.route;
		let { siteConfig } = this.props;
		let showNewViewSearch = siteConfig?.settings?.show_new_view_search;

		return (
			<>
				{this.canonical()}

				<SeoBlockHOC route={route} placeText="AddressSearch">
					<AddressSearchContainer
						callback={(value) => this.handleChoose(value)}
						sendGAWhenFulled={true}
						showNewViewSearch={showNewViewSearch}
						buttonName="найти"
					/>
				</SeoBlockHOC>

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock1" bgText={true} />

					<ProvidersContainer />

					<SeoBlockContainer route={route} placeText="SeoBlock2" bgText={true} />
				</Container>

				<AddressAdverBlockContainer autoExpansion={!showNewViewSearch} />

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock3" bgText={true} />
				</Container>

				<SeoBlockHOC route={route} placeText="TopProvider">
					<TopProviderContainer backgroundNone={true} />
				</SeoBlockHOC>

				<Container>
					<SeoBlockContainer route={route} placeText="SeoBlock4" bgText={true} />

					<DeclinationContainerNew>
						<Districts />
					</DeclinationContainerNew>
				</Container>
			</>
		);
	}
}

export default withRouter(inject("ApplicationModel")(Page));
